import { ReactNode, useCallback } from 'react'
import { interpolate, Renderers } from 'lib/string/interpolate'
import { useSocieteVariables, SocieteVariables } from './useSocieteVariables'

export interface SocieteInterpolate {
  (text: string): string
  (text: string, renderers: Renderers<SocieteVariables>): ReactNode
}

/**
 * Returns a function that substitutes Société variables in a text.
 *
 * Pass `renderers` to render selected placeholders as React nodes (e.g. bold).
 * Without renderers it returns a plain string; with renderers it returns a `ReactNode`.
 */
export function useSocieteInterpolate(): SocieteInterpolate {
  const vars = useSocieteVariables()

  return useCallback(
    ((text: string, renderers?: Renderers<SocieteVariables>) => (
      renderers ? interpolate(text, vars, renderers) : interpolate(text, vars)
    )) as SocieteInterpolate,
    [vars],
  )
}
